//import region
import React, { useState, useEffect } from 'react';

// bootstrap
import Row from 'react-bootstrap/Row';
//styles
import { Colors } from '_styles';
//custom components
import { BookingTable } from '_organisms';

const BookingCard = ({ bookings }) => {
    // state variables
    const [displayBookings, setDisplayBookings] = useState([]);

    // set assistance
    useEffect(() => {

        if (bookings) {
            let holderList = [];
            bookings.forEach(booking => {
                if (!booking) return;
                // check if booking is an error booking
                if (booking.error && booking.error.length > 0) {
                    holderList.push(booking)
                }
                else {
                    holderList.push({
                        'passenger': booking.name.toLowerCase(),
                        'date': booking.flightConfirmationDetails.departureDate,
                        'flight': booking.flightConfirmationDetails.carrierCode + booking.flightConfirmationDetails.flightNumber,
                        'origin': booking.flightConfirmationDetails.origin,
                        'destination': booking.flightConfirmationDetails.destination,
                        'assistance': booking.assistance,
                        'bio': booking.bio ? booking.bio : '',
                        'timeCreated': booking.dateCreated ? booking.dateCreated : ''
                    })
                }
            });

            setDisplayBookings(holderList)
        }
    }, [bookings]);

    return (
        <Row style={{}}>
            {
                bookings == null ?
                    <div style={{ textAlign: 'center', padding: 20 }}>
                        <p style={{ fontWeight: 'bold', fontSize: 22, opacity: 0.6, color: Colors.TEXT_COLOR }}>Error</p>
                        <p style={{ fontWeight: '300', fontSize: 22, opacity: 0.6, color: Colors.TEXT_COLOR }}>Issue loading booking information</p>
                        <p style={{ fontWeight: '300', fontSize: 22, opacity: 0.6, color: Colors.TEXT_COLOR }}>Please try again later.</p>
                    </div>
                    :
                    <BookingTable data={displayBookings} showDate={true} />
            }

        </Row>
    )
}

export default BookingCard;
